module.exports = "folder-closed"